import React, { useEffect, useState } from "react";
import SettingsMenu from "../../components/settingMenu/SettingMenu";
import Templates from "../../components/templates/Templates";
import { useSelector } from "react-redux";
import {
  useGetTemplatesQuery,
  useGetUserByIdQuery,
  useGetTemplatesHeaderFooterQuery,
} from "store/api/apiSlice";

const TemplatesPage = () => {
  const { user } = useSelector((state) => state.user);
  const { data: userProfile, isLoading: userLoading } = useGetUserByIdQuery(
    user.id,
    {
      skip: !user?.id,
      pollingInterval: 60000,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    },
  );
  const { data: templates, isLoading: templatesLoading } = useGetTemplatesQuery(
    userProfile?.user?.companyId,
    {
      skip: !userProfile?.user?.companyId,
    },
  );

  const {
    data: templatesHeaderFooter,
    isLoading: templatesHeaderFooterLoading,
  } = useGetTemplatesHeaderFooterQuery(userProfile?.user?.companyId, {
    skip: !userProfile?.user?.companyId,
  });

  const [emailTemplates, setEmailTemplates] = useState([]);
  const [smsTemplates, setSmsTemplates] = useState([]);
  const [headerTemplates, setHeaderTemplates] = useState([]);
  const [footerTemplates, setFooterTemplates] = useState([]);

  useEffect(() => {
    if (templates && templates?.templates?.length > 0) {
      setEmailTemplates(
        templates?.templates?.filter(
          (t) => t.type === "email" && !t.resetPassword && !t.newUser,
        ),
      );
    }
  }, [templates]);

  useEffect(() => {
    if (templates && templates?.templates?.length > 0) {
      setSmsTemplates(
        templates?.templates?.filter(
          (t) => t.type === "sms" && !t.resetPassword && !t.newUser,
        ),
      );
    }
  }, [templates]);

  useEffect(() => {
    if (templatesHeaderFooter && templatesHeaderFooter?.templates?.length > 0) {
      setHeaderTemplates(
        templatesHeaderFooter?.templates?.filter((t) => t.type === "h"),
      );
      setFooterTemplates(
        templatesHeaderFooter?.templates?.filter((t) => t.type === "f"),
      );
    }
  }, [templatesHeaderFooter]);

  if (userLoading || templatesLoading || templatesHeaderFooterLoading)
    return null;

  return (
    <SettingsMenu>
      <Templates
        emailTemplates={emailTemplates}
        smsTemplates={smsTemplates}
        headerTemplates={headerTemplates}
        footerTemplates={footerTemplates}
      />
    </SettingsMenu>
  );
};

export default TemplatesPage;
